module.exports = __webpack_public_path__ + "static/media/ceremonie.f27186a2.jpg";